import React from 'react';
import 'twin.macro';
import { useTranslation } from 'react-i18next';
import { allFields, useFieldsToDisplay, useToggleFieldToDisplay } from './atom';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import { BOLabels } from 'types/user';
import { Field } from 'containers/CahierJournal/Toolbar/Filters/FieldsToDisplay/types';
import { ButtonDisplay } from 'components/Buttons/ButtonDisplay';

function matchBoLabel(field: Field, boLabels: BOLabels) {
  switch (field) {
    case 'Matieres': {
      return boLabels.matierePluralName;
    }
    case 'Domaines': {
      return boLabels.domainePluralName;
    }
    case 'Competences': {
      return boLabels.competencePluralName;
    }
    case 'Objectifs': {
      return boLabels.objectifPluralName;
    }
    case 'Activités': {
      return boLabels.activitiesName;
    }
    default: {
      return field;
    }
  }
}

interface Props {
  withStatus: boolean;
}

export function FieldsToDisplay(props: Props) {
  const { boLabels } = useUser();

  const { t } = useTranslation(['common', 'cahierJournal']);
  const fields = useFieldsToDisplay();
  const toggleField = useToggleFieldToDisplay();
  return (
    <div tw="flex flex-wrap gap-2">
      {allFields
        .filter(f => props.withStatus || f !== 'status')
        .map(field => {
          const label = matchBoLabel(field, boLabels);
          return (
            <ButtonDisplay
              onClick={() => toggleField(field)}
              active={fields.includes(field)}
              key={field}
            >
              {t(`cahierJournal:toolbar.filter.fields.${label}`, {
                defaultValue: label,
              })}
            </ButtonDisplay>
          );
        })}
    </div>
  );
}
